import clsx from 'clsx';
import {AnimatePresence, motion} from 'motion/react';
import {APP_ANIMATIONS} from '@/const';
import AnimatedLoader from '@/icons/AnimatedLoader';
import styles from './styles.module.scss';

export enum LOADER_SIZES {
    xs = styles.xs,
    sm = styles.sm,
    md = styles.md,
    lg = styles.lg,
    xl = styles.xl
}

export interface ILoaderProps {
    loading?: boolean;
    size?: LOADER_SIZES;
    loaderStyles?: string[];
}

const Loader = ({loading = false, size = LOADER_SIZES.xl, loaderStyles = []}: ILoaderProps) => {
    return (
        <AnimatePresence>
            {loading && (
                <motion.span {...APP_ANIMATIONS.fadeInOut} className={clsx(styles.loader, size, ...loaderStyles)}>
                    <AnimatedLoader />
                </motion.span>
            )}
        </AnimatePresence>
    );
};

export default Loader;
